import { Directive, inject, output } from '@angular/core';
import { FormComponent } from '@toevla-webapplications/core';
import { FormBuilder } from '@angular/forms';

@Directive()
export class FormSubmitComponent extends FormComponent {
	cancel = output();
	submit = output<any>();

	protected readonly fb = inject(FormBuilder);

	doCancel() {
		this.cancel.emit();
	}

	doSubmit() {
		if (this.isFormValid()) {
			this.submit.emit(this.getFormData());
		}
	}
}
